import { authorizationStore } from "../store/authorizationStore";

const baseURL = (() => {
  if (process && process.env && process.env.NODE_ENV === 'development' && process.env.BASE_URL) {
    return process.env.BASE_URL;
  }
  return window.appConfig && window.appConfig.baseURL ? window.appConfig.baseURL : location.origin;
})(); 
const fileUploadURL = baseURL ? `${baseURL}/api/fileupload` : '/api/fileupload';

const baseServer = 'Inistate';

const baseLocationOrigin = baseURL.includes('api.inistate.com') ? 'https://app.inistate.com' : baseURL;

const previewAppURL = window.appConfig && window.appConfig.previewAppURL ? window.appConfig.previewAppURL : 'https://m.inistate.com';

const previewWebURL = window.appConfig && window.appConfig.previewWebURL ? window.appConfig.previewWebURL : location.origin;

// Hosts the admin-panel SSO handoff (FTSLogin -> /api/account/sso/authorize) may bounce
// back to. Loopback is always permitted for local dev (see FTSLogin.ssoReturnUrl);
// override in webApp.config.json for staging/prod admin origins.
const allowedAdminHosts = window.appConfig && Array.isArray(window.appConfig.allowedAdminHosts)
  ? window.appConfig.allowedAdminHosts
  : ['admin.inistate.com'];

const buildVersion = '261101.2629';

const getConfig = async () => {
  try {
    const res = await fetch('webApp.config.json');
    const data = await res.json();
    if (data) {
      authorizationStore.dispatch('setAppConfig', data);
    }
  } catch(err) {
    console.warn(err)
  }
}

export default {
  baseServer: baseServer,
  baseURL: baseURL,
  baseLocationOrigin: baseLocationOrigin,
  previewAppURL: previewAppURL,
  previewWebURL: previewWebURL,
  fileUploadURL: fileUploadURL,
  allowedAdminHosts: allowedAdminHosts,
  buildVersion: buildVersion,
  getConfig: getConfig,
}